/* @flow */

import * as React from 'react';

import {IconButton} from 'shells/button/icon-button/icon-button';
import {EditableCurrencyField} from 'shells/formatted-number-field/editable-currency-field';
import {RetryIcon} from 'shells/icon/svg/retry-icon';
import {Stack} from 'shells/layout/stack/stack';

import './value-editor.module.css';

type Props = {|
    value: number,
    productValueFormatted: string,
    currencyCode: ?string,
    onSubmit: (number) => void,
    isEditing: boolean,
    setIsEditing: (boolean) => void,
    isSmall?: boolean,
    onReset: () => void,
    isInManualValueMode?: boolean,
    shouldSubmitOnBlur?: boolean,
|};

export function ValueEditor(props: Props) {
    const {onReset, isInManualValueMode, productValueFormatted, ...restProps} = props;

    return (
        <Stack
            isHorizontal={true}
            isFullWidth={true}
            justifyContent='end'
            spacing={6}
            alignItems='center'
        >
            <EditableCurrencyField {...restProps} />
            {!props.isEditing && isInManualValueMode && (
                <div styleName='reset-button'>
                    <IconButton
                        icon={RetryIcon}
                        noPadding={true}
                        onClick={onReset}
                        tooltipText={`Reset value to ${productValueFormatted} to match products`}
                    />
                </div>
            )}
        </Stack>
    );
}
